import { useQuery } from "@tanstack/react-query";

import { analysisUsageQueryOptions } from "./analysisUsageQueryOptions";

// Разборы пользователя: лимит на скользящие сутки, сколько из него потрачено, когда освободится
// следующий и сколько матчей разобрано за всё время.
export const useAnalysisUsage = () => useQuery(analysisUsageQueryOptions());
